<script>
  import { factoryStore } from "./../store/factories.js";
  import { fade } from "svelte/transition";
  import { langTextStore } from "../store/langtexts.js";
  import { countryStore } from "../store/countries.js";
  import { calculatorStore } from "../store/calculators.js";
  import { inputVariableStore } from "../store/inputVariables.js";
  import { createEventDispatcher, tick } from "svelte";
  import { getContext } from "svelte";
  import InputVar from "../SharedComponents/InputVar.svelte";
  import InputMoney from "../SharedComponents/InputMoney.svelte";
  import TitleWithHelp from "../SharedComponents/TitleWithHelp.svelte";
  import { outputVariableStore } from "../store/outputVariables.js";
  import * as util from "../js/util.js";
  import { each } from "svelte/internal";
  import Cloud from "../Vectors/Cloud.svelte";
  import Download from "../Vectors/Download.svelte";

  const { snackbar } = getContext("app");
  const dispatch = createEventDispatcher();
  export let isFactory;
  isFactory = isFactory;
  export let currentSubSectionNameKey;
  export let readonly = false;
  $: subSection =
    $calculatorStore.subSections &&
    currentSubSectionNameKey &&
    $calculatorStore.subSections.find(
      (ss) => ss.subSectionNameKey == currentSubSectionNameKey
    );

  function saveToCloud() {
    dispatch("saveToCloud", null);
  }
  $: selectInitialField(currentSubSectionNameKey);
  let justForcedMinTargetWage = false;
  var minwageTimer = null;
  //   function checkTargetWageAndBubble() {
  //     if (false) {
  //       var wageVar = $calculatorStore.variables.find(
  //         (v) => v.varNameKey == "Wage"
  //       );
  //       if (
  //         $inputVariableStore.scenarioConfiguration.scenarioVarValues[
  //           "target-wage"
  //         ]["Wage"] < wageVar.minValue
  //       ) {
  //         $inputVariableStore.scenarioConfiguration.scenarioVarValues[
  //           "target-wage"
  //         ]["Wage"] = wageVar.minValue;
  //         justForcedMinTargetWage = true;
  //         clearTimeout(minwageTimer);
  //         minwageTimer = window.setTimeout(() => {
  //           justForcedMinTargetWage = false;
  //         }, 3000);
  //       }
  //     }
  //     bubbleChange();
  //   }
  async function selectInitialField(p) {
    await tick();
    var x = document.getElementsByTagName("input");
    if (x.length > 0) {
      x[0].focus();
    }
  }

  function getCurrency(theCurrencyId) {
    var currencyNameObj = $factoryStore.currencies.find(
      (c) => c.id == theCurrencyId
    );
    if (currencyNameObj != null) {
      return currencyNameObj.nameKey;
    }
    return "";
  }

  async function changeFactorySetting(event) {
    factoryStore.setFactorySettingToCurrentProduct(
      event.detail.factorySettingId
    );
  }
  var loadingCurrency = false;
  async function setCurrency() {
    loadingCurrency = true;
    await tick();
    await tick();
    await tick();
    window.setTimeout(async () => {
      var mainCurrencyName = $factoryStore.currencies.find(
        (c) => c.id == $factoryStore.currentCalculator.currencyId
      ).nameKey;
      var alternateCurrencyName = $factoryStore.currencies.find(
        (c) => c.id == $factoryStore.currentCalculator.alternateCurrencyId
      ).nameKey;

      try {
        const res = await fetch(
          "https://v6.exchangerate-api.com/v6/648985a865d16d229438af26/pair/" +
            alternateCurrencyName +
            "/" +
            mainCurrencyName
        );
        const json = await res.json();
        var rate = json.conversion_rate;
        inputVariableStore.update((n) =>
          Object.assign(n, { alternateCurrencyRate: rate })
        );

        $factoryStore.currentCalculator.alternateCurrencyRate = rate;
        loadingCurrency = false;
      } catch (s) {
        loadingCurrency = false;
        snackbar("error", "failed to get exchange rate");
      }
      factoryStore.update((n) => n);
      inputVariableStore.update((n) => n);
      factoryStore.update((n) => n);

      bubbleChange();
    }, 400);
  }

  async function updateStuff() {
    var y = factorySettingsSubSection;
    var checked = event.currentTarget.checked;
    factorySettingsSubSection.markAsComplete = checked;
    dispatch("change", null);
  }
  async function selectLastField(p) {
    await tick();
    var x = document.getElementsByTagName("input");
    if (x.length > 0) {
      x[x.length - 1].focus();
    }
  }

  var bubbletimeout;
  function bubbleChange(e) {
    try {
      window.clearTimeout(bubbletimeout);
      bubbletimeout = window.setTimeout(() => {
        dispatch("change", null);
      }, 500);
    } catch (s) {}
  }

  async function checkNextOrPrevious(e) {
    if (e.key == "Tab" || e.code == "Tab") {
      var direction = e.shiftKey ? "prev" : "next";
      let varName = e.target.getAttribute("varname");
      if (!subSection) {
        //alert("not tabbing on custom tabs yet");
        return;
      }
      if (direction == "next") {
        var lastVar = subSection.variables[subSection.variables.length - 1];
        if (lastVar.nameKey == varName) {
          dispatch("next", null);
          window.setTimeout(() => {
            selectInitialField();
          }, 100);
        }
      } else {
        var firstVar = subSection.variables[0];
        if (firstVar.nameKey == varName) {
          dispatch("previous", null);
          window.setTimeout(() => {
            selectLastField();
          }, 100);
        }
      }
    }
  }

  $: factorySettingsSubSection =
    subSection &&
    $factoryStore.currentCalculator &&
    $factoryStore.currentCalculator.subSections &&
    $factoryStore.currentCalculator.subSections.find(
      (ss) => ss.subSectionNameKey == subSection.subSectionNameKey
    );

  checkWageVar($calculatorStore);
  function checkWageVar() {
    if ($calculatorStore.variables.length > 0) {
      var x = $calculatorStore.variables.find((v) => v.varNameKey == "Wage");
      if (x == null) {
        alert("error! missing Wage var");
      }
    }
  }

  $: fillFactorySettingName($factoryStore.currentCalculator.factorySettingId);
  let factorySettingName = "";
  async function fillFactorySettingName(settingId) {
    if (!settingId) return;
    factorySettingName = await factoryStore.getFactorySettingName(
      $factoryStore.currentCalculator.factorySettingId
    );
  }

  $: currentCalculator = $factoryStore.currentCalculator;

  $: $inputVariableStore.scenarioConfiguration &&
    $inputVariableStore.scenarioConfiguration.scenarioVarValues[
      "target-wage"
    ] &&
    setTargetWageInBaseCalculation(
      $inputVariableStore.scenarioConfiguration.scenarioVarValues[
        "target-wage"
      ]["Wage"]
    );

  function setTargetWageInBaseCalculation(targetWage) {
    $inputVariableStore["TargetWage"] = targetWage;
  }

  $: setRelevantCurrencies($factoryStore.currentCalculator.currencyId);

  let relevantCurrencies = [];
  function setRelevantCurrencies(crntId) {
    relevantCurrencies = $factoryStore.currencies.filter((c) => {
      return c.id == 1 || c.id == 2 || c.id == 3 || c.id == crntId;
    });
  }

  function sentenceCase(txt) {
    return util.sentenceCase(txt, false);
  }
</script>

<div class="xh-100 position-relative">
  {#if subSection}
    <h2 class="highlight" style="text-transform:none">
      {sentenceCase($langTextStore.getText(subSection.subSectionNameKey))}
    </h2>
    <div class="w-100 mb-3 mt-2 mb-lg-0">&nbsp;</div>
    {#each subSection.variables as variable}
      {#if variable.nameKey == "WageDistribution"}
        <button
          class="btn btn-primary"
          on:click={() => dispatch("showWageDistribution", null)}
        >
          {$langTextStore.getText("general-wage-distribution")}</button
        >
      {:else if variable.nameKey.toLowerCase() == "productname"}
        <label for={"inputfield-input-basic-settings-product-name"}>
          <TitleWithHelp
            variable={{
              nameKey: "basic-settings-product-name",
            }}
          />
        </label>
        <input
          type="text"
          {readonly}
          class:readonly
          disabled={readonly}
          on:change={bubbleChange}
          on:keydown={checkNextOrPrevious}
          on:focus={(e) => {
            e.target.select();
          }}
          id={"inputfield-input-basic-settings-product-name"}
          bind:value={$factoryStore.currentCalculator.name}
        />
      {:else if variable.nameKey.toLowerCase() == "brand"}
        <label for={"inputfield-input-basic-settings-brand-name"}>
          <TitleWithHelp
            variable={{
              nameKey: "basic-settings-brand-name",
            }}
          />
        </label>
        <input
          type="text"
          {readonly}
          class:readonly
          disabled={readonly}
          on:change={bubbleChange}
          on:keydown={checkNextOrPrevious}
          on:focus={(e) => {
            e.target.select();
          }}
          id={"inputfield-input-basic-settings-brand-name"}
          bind:value={$factoryStore.currentCalculator.brand}
        />
      {:else if variable.nameKey.toLowerCase() == "style"}
        <label for={"inputfield-input-basic-settings-style-name"}>
          <TitleWithHelp
            variable={{
              nameKey: "basic-settings-style-name",
            }}
          />
        </label>
        <input
          type="text"
          {readonly}
          class:readonly
          disabled={readonly}
          on:change={bubbleChange}
          on:keydown={checkNextOrPrevious}
          on:focus={(e) => {
            e.target.select();
          }}
          id={"inputfield-input-basic-settings-style-name"}
          bind:value={$factoryStore.currentCalculator.style}
        />
      {:else if variable.nameKey.toLowerCase() == "wage"}
        <label for={"inputfield-input-base-wage"}>
          <TitleWithHelp
            variable={{
              nameKey: "basic-settings-wage-base-wage",
            }}
          />
        </label>
        {#if variable.readOnly}
          <input
            type="number"
            on:change={bubbleChange}
            on:keydown={checkNextOrPrevious}
            id={"inputfield-input-base-wage"}
            readonly={variable.readOnly}
            on:focus={(e) => {
              e.target.select();
            }}
            class:readonly={variable.readOnly}
            bind:value={$outputVariableStore["Wage"]}
          />{:else}
          <InputVar
            {readonly}
            on:keydown={checkNextOrPrevious}
            on:keyup={bubbleChange}
            on:change={bubbleChange}
            bind:subSection
            bind:variable
          />
        {/if}
        {#if $inputVariableStore.scenarioConfiguration && $inputVariableStore.scenarioConfiguration.scenarios}
          <!-- {#each $inputVariableStore.scenarioConfiguration.scenarios as scenario} -->
          <label for={"inputfield-input-scenario-wage"}>
            <TitleWithHelp
              variable={{
                nameKey: "factory-settings-scenario-target-wage",
              }}
            />
          </label>
          <span id="fixmoney">
            <InputMoney
              on:change={bubbleChange}
              min={$calculatorStore.variables.find(
                (v) => v.varNameKey == "Wage"
              ).minValue}
              max={$calculatorStore.variables.find(
                (v) => v.varNameKey == "Wage"
              ).maxValue}
              on:focus={(e) => {
                e.target.select();
              }}
              mainCurrencyId={$factoryStore.currentCalculator.currencyId}
              alternateCurrencyId={$factoryStore.currentCalculator
                .alternateCurrencyId}
              alternateCurrencyRate={$inputVariableStore.alternateCurrencyRate}
              on:change={() => bubbleChange()}
              bind:value={$inputVariableStore.scenarioConfiguration
                .scenarioVarValues["target-wage"]["Wage"]}
            />
          </span>
          {#if $calculatorStore.variables.find((v) => v.varNameKey == "Wage").minValue > 0}
            <span class="input-help" class:alert={justForcedMinTargetWage}
              >Minimum: {$calculatorStore.variables.find(
                (v) => v.varNameKey == "Wage"
              ).minValue}
            </span>
          {/if}
        {/if}
      {:else}
        <div in:fade={{ duration: 800 }}>
          <div class="row g-0 text-small mb-3 mb-lg-0">
            <label
              for={"inputfield-input-" +
                subSection.subSectionNameKey +
                variable.nameKey}
            >
              <TitleWithHelp {variable} />
            </label>
            <InputVar
              {readonly}
              on:keydown={checkNextOrPrevious}
              on:keyup={bubbleChange}
              on:change={bubbleChange}
              bind:subSection
              bind:variable
            />
          </div>
        </div>
      {/if}
    {/each}
  {:else if currentSubSectionNameKey == "basic-settings"}
    <h2 class="highlight">
      {$langTextStore.getText("factory-settings-basic-settings-header")}
    </h2>
    <div class="w-100 mb-3 mt-2 mb-lg-0">&nbsp;</div>
    {#if !isFactory}
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label>
        <TitleWithHelp
          variable={{
            nameKey: "basic-settings-factory-setting-based-on",
          }}
        />
      </label>
      <a
        on:click={saveToCloud}
        href="#/calculator/factorysettings/{$factoryStore.currentCalculator
          .factorySettingId}?fromproduct={$factoryStore.currentCalculator.uuid}"
      >
        {#await factoryStore.getFactoryAndVersionName(currentCalculator.factorySettingId) then name}
          {name}
        {/await}</a
      >
      <br />

      <br />
    {/if}
    <label for="country">{$langTextStore.getText("country")}</label>
    <input
      type="text"
      id="country"
      class="readonly"
      readonly
      value={currentCalculator.country}
    />

    {#if isFactory}
      <label for={"inputfield-input-basic-settings-name"}>
        <TitleWithHelp
          variable={{
            nameKey: "basic-settings-name",
          }}
        />
      </label>
      <input
        type="text"
        {readonly}
        class:readonly
        disabled={readonly}
        on:keydown={checkNextOrPrevious}
        on:keyup={bubbleChange}
        on:focus={(e) => {
          e.target.select();
        }}
        id={"inputfield-input-basic-settings-name"}
        bind:value={$factoryStore.currentFactory.name}
      />
      <label for={"inputfield-input-basic-settings-version-name"}>
        <TitleWithHelp
          variable={{
            nameKey: "basic-settings-version-name",
          }}
        />
      </label>
      {#if !readonly}
        <input
          type="text"
          {readonly}
          class:readonly
          disabled={readonly}
          on:change={bubbleChange}
          on:keydown={checkNextOrPrevious}
          on:focus={(e) => {
            e.target.select();
          }}
          id={"inputfield-input-basic-settings-version-name"}
          bind:value={$factoryStore.currentCalculator.name}
        />
      {:else}
        <input
          type="text"
          {readonly}
          class:readonly
          disabled={readonly}
          on:change={bubbleChange}
          on:keydown={checkNextOrPrevious}
          on:focus={(e) => {
            e.target.select();
          }}
          id={"inputfield-input-basic-settings-version-name"}
          value={factorySettingName}
        />
      {/if}
    {/if}

    {#if !readonly}
      <label for="basecurrency">
        <TitleWithHelp
          variable={{
            nameKey: "factory-settings-basic-settings-base-currency-name",
          }}
        />
      </label>
      <input
        id="basecurrency"
        type="text"
        readonly="readonly"
        disabled="true"
        value={getCurrency($factoryStore.currentCalculator.currencyId)}
      />

      <label for={"inputfield-input-basic-settings-alternate-currency-name"}>
        <TitleWithHelp
          variable={{
            nameKey: "basic-settings-alternate-currency-name",
          }}
        />
      </label>
      <select
        on:keydown={checkNextOrPrevious}
        on:change={async () => {
          bubbleChange();
          setCurrency();
        }}
        on:blur={() => {}}
        class:readonly
        disabled={readonly}
        bind:value={$factoryStore.currentCalculator.alternateCurrencyId}
      >
        {#each relevantCurrencies as currency}
          <option value={currency.id}>{currency.nameKey}</option>
        {/each}
      </select>

      <label for={"inputfield-input-basic-settings-alternate-currency-rate"}>
        <TitleWithHelp
          variable={{
            nameKey: "basic-settings-alternate-currency-rate",
          }}
        />
      </label>
      <div style="display:flex">
        <input
          type="number"
          on:focus={(e) => {
            e.target.select();
          }}
          on:change={bubbleChange}
          on:keydown={checkNextOrPrevious}
          id={"inputfield-input-basic-settings-alternate-currency-rate"}
          bind:value={$inputVariableStore.alternateCurrencyRate}
          class:readonly
          disabled={readonly || loadingCurrency}
        />
        <div style="margin-top:5px;margin-left:5px">
          <Download on:click={setCurrency} />
        </div>
      </div>
      <label for={"inputfield-input-basic-settings-input-currency"}>
        <TitleWithHelp
          variable={{
            nameKey: "basic-settings-input-currency",
          }}
        />
      </label>
      <select
        on:keydown={checkNextOrPrevious}
        on:change={async () => {
          bubbleChange();
          setCurrency();
        }}
        on:blur={() => {}}
        class:readonly
        disabled={readonly}
        bind:value={$factoryStore.currentCalculator.inputCurrency}
      >
        <option value={"base"}
          >{$langTextStore.getText("general-label-base-currency")}</option
        >
        <option value={"alternate"}
          >{$langTextStore.getText("general-label-alternate-currency")}</option
        >
      </select>
    {/if}
  {/if}
</div>
{#if factorySettingsSubSection}
  <p class="mt-1">
    <label
      ><input
        type="checkbox"
        checked={factorySettingsSubSection.markAsComplete}
        {readonly}
        class:readonly
        disabled={readonly}
        on:click={() => {
          updateStuff();
          snackbar(
            "info",
            langTextStore.getText("general-label-section-marked-complete-saved")
          );
        }}
      />
      {$langTextStore.getText("general-label-section-marked-complete")}</label
    >
  </p>
{/if}

<style>
  label {
    display: block;
    width: 100%;
  }
  .readonly {
    background: #ccc;
  }

  :global(#fixmoney > .prelabel) {
    margin-top: 5px;
  }
</style>
